module.exports = __webpack_public_path__ + "static/media/rectangle-4.82c760f2.svg";